import React from 'react';

const SectionIndicator = ({ sections, currentSection, scrollToSection }) => {
  return (
    <div className="fixed top-1/2 right-4 transform -translate-y-1/2 flex flex-col items-center space-y-3 z-50">
      {sections.map((sectionId) => {
        const isActive = sectionId === currentSection;
        return (
          <button
            key={sectionId}
            onClick={() => scrollToSection(sectionId)}
            className={`transition-opacity duration-150 ease-in-out focus:outline-none group ${isActive ? 'opacity-100' : 'opacity-60 hover:opacity-100'}`}
            aria-label={`Scroll to ${sectionId.replace('-', ' ')}`}
            title={sectionId.replace('-', ' ').replace(/\b\w/g, l => l.toUpperCase())}
          >
            <div
              className={`
                w-2 h-2 rounded-full transition-all duration-150 ease-out ml-4
                ${isActive
                  ? 'bg-[#16B08B]'
                  : 'bg-neutral-700 group-hover:bg-[#16B08B]/60'
                }
              `}
            />
          </button>
        );
      })}
    </div>
  );
};

export default SectionIndicator; 